import { StatusObjType } from "./workStatus";

export const externalUserTypeColor = {
  SALES: "blue.7",
  PURCHASE: "green.7",
  BI_DIRECTION: "yellow.7",
  OUTSOURCING: "pink.7",
};

export const externalUserType: StatusObjType = {
  SALES: "user.SALES",
  PURCHASE: "user.PURCHASE",
  BI_DIRECTION: "user.BI_DIRECTION",
  OUTSOURCING: "user.OUTSOURCING",
};

export const setExternalUserType = (status: string | undefined) => {
  return externalUserType[status ?? ""];
};
